/* import __COLOCATED_TEMPLATE__ from './api-version-notice.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { dropTask, timeout } from 'ember-concurrency';
let ApiVersionNoticeComponent = (_class = class ApiVersionNoticeComponent extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "apiVersion", _descriptor, this);
    _initializerDefineProperty(this, "mismatched", _descriptor2, this);
    _initializerDefineProperty(this, "updateAvailable", _descriptor3, this);
    _initializerDefineProperty(this, "countdownToUpdate", _descriptor4, this);
    _initializerDefineProperty(this, "showReloadButton", _descriptor5, this);
    _defineProperty(this, "check", _buildTask(() => ({
      context: this,
      generator: function* () {
        const mismatched = yield this.apiVersion.getIsMismatched();
        if (mismatched && 'serviceWorker' in navigator) {
          yield 2000; //wait to let the new service worker get fetched if it is available
          const reg = yield navigator.serviceWorker.getRegistration();
          if (reg) {
            if (reg.waiting) {
              this.update.perform();
            } else {
              reg.onupdatefound = () => {
                this.countdown.perform();
              };
            }
          } else {
            this.showReloadButton = true;
          }
        }
        this.mismatched = mismatched;
        return true; //always return true to update data-test-load-finished property
      }
    }), null, "check", "drop"));
    _defineProperty(this, "countdown", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.updateAvailable = true;
        for (let i = 5; i > 0; i--) {
          this.countdownToUpdate = i;
          yield timeout(1000);
        }
        yield this.update.perform();
      }
    }), null, "countdown", "drop"));
    _defineProperty(this, "update", _buildTask(() => ({
      context: this,
      generator: function* () {
        if ('serviceWorker' in navigator) {
          const reg = yield navigator.serviceWorker.getRegistration();
          if (reg && reg.waiting) {
            reg.waiting.postMessage('skipWaiting');
          }
        }
        yield timeout(3000);
      }
    }), null, "update", "drop"));
    this.check.perform();
  }
  reload() {
    window.location.reload();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "apiVersion", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "mismatched", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "updateAvailable", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "countdownToUpdate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showReloadButton", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { ApiVersionNoticeComponent as default };